import { useState, useEffect, useRef, Fragment, memo, useMemo,useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./Collaborative.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import SearchIcon from '@mui/icons-material/Search';
import { GameContext } from "../../GameContext";
import ImageLoader from "../../comm/global/components/ImageLoader";
const Collaborative = ({ setModalType, arg, addModalType }) => {
    const { userData } = useContext(GameContext);
    const [inProp, setInProp] = useState(false);
    const [targetFriend, set_targetFriend] = useState(null);
    const scrollableRef = useRef(null);
    const contentRef = useRef(null);
    const maskRef = useRef(null);

    useEffect(() => {
        console.log("Collaborative");
        setInProp(true);
        if (scrollableRef.current && maskRef.current) {
            const h = scrollableRef.current.clientHeight;
            maskRef.current.style.minHeight = `${h}px`;
            scrollableRef.current.style.maxHeight = `${h}px`;
            scrollableRef.current.scrollTop = h;
        }
    }, [])

    function updateHeight() {
        if (scrollableRef.current && maskRef.current) {
            const h = contentRef.current.clientHeight;
            maskRef.current.style.minHeight = `${h}px`;
            scrollableRef.current.style.maxHeight = `${h}px`;
            scrollableRef.current.scrollTop = h;
        }
    }
    function releseHand(e) {
        if (scrollableRef.current.scrollTop < scrollableRef.current.clientHeight * .9) {
            scrollableRef.current.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
            setTimeout(() => {
                setInProp(false);
            }, 500);
        }
        else
            scrollableRef.current.scrollTo({
                top: scrollableRef.current.clientHeight,
                left: 0,
                behavior: "smooth",
            })
    }

    return (
        <div className={style.modalBottom} style={{ backgroundColor: "#00000055", overflow: "hidden" }}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "Collaborative"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app} ref={scrollableRef} onTouchEnd={e => { releseHand(e) }} onMouseUp={e => { releseHand(e) }} onScroll={e => {
                                if (e.target.scrollTop === 0)
                                    setInProp(false);
                            }}>
                                <div className={styleUi.mask} ref={maskRef}>
                                </div>
                                <div className={styleUi.content} ref={contentRef} >
                                    <div className={styleUi.view}>
                                        <YStyled.Span size={20} fontFamily="SF Pro" className={styleUi.title}>共同回憶</YStyled.Span>
                                        <div className={styleUi.users}>
                                            <div className={styleUi.userProfile}>
                                                <div className={styleUi.icon}>
                                                    <ImageLoader variant={"circular"} width={"100%"} height={"100%"} src={userData.user_avatar} />
                                                </div>
                                                <div className={styleUi.nameBox}>
                                                    <YStyled.Span size={17} >{userData.users_name}</YStyled.Span>
                                                </div>
                                            </div>
                                            <img src="./assets/ui/add.png" />
                                            {targetFriend ?
                                                <div className={`${styleUi.userProfile} ${styleUi.target}`}>
                                                    <div className={styleUi.icon}>
                                                        <ImageLoader variant={"circular"} width={"100%"} height={"100%"} src={targetFriend.user_avatar} />
                                                    </div>
                                                    <div className={styleUi.nameBox}>
                                                        <YStyled.Span size={17} >{targetFriend.user_name}</YStyled.Span>
                                                    </div>
                                                    <YStyled.Span size={13} color="#007AFF" onClick={e => {
                                                        addModalType({
                                                            cls: "FriendSearch", arg: {
                                                                cb: friendVo => {
                                                                    set_targetFriend(friendVo)
                                                                }
                                                            }
                                                        })
                                                    }}>重設</YStyled.Span>
                                                </div>
                                                :
                                                <div className={`${styleUi.userProfile} ${styleUi.empty}`}>
                                                    <div className={`${styleUi.icon} ${styleUi.empty}`}>
                                                        <img src="./assets/ui/user.png" />
                                                    </div>
                                                    <div className={styleUi.nameBox} onClick={e => {
                                                        addModalType({
                                                            cls: "FriendSearch", arg: {
                                                                cb: friendVo => {
                                                                    set_targetFriend(friendVo)
                                                                }
                                                            }
                                                        })
                                                    }}>
                                                        <SearchIcon />
                                                        <YStyled.Span size={17} color="#0000000A">搜尋好友</YStyled.Span>
                                                    </div>
                                                </div>
                                            }


                                        </div>
                                        <YStyled.BTN3 disabled={targetFriend===null} disableBg="#888888" normalBg="#000" style={{ width: "100%", color: "#fff", marginTop: "3rem",borderRadius:"10px",padding:"9px 66px" }} onClick={e => {
                                            arg.cb(targetFriend);
                                            setInProp(false);
                                        }}>
                                            <YStyled.Span size={17} >查看</YStyled.Span>
                                        </YStyled.BTN3>
                                        <div className={styleUi.close} onClick={e => {
                                            setInProp(false);
                                        }}>
                                            <img src="./assets/ui/x.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition >
        </div >
    );
}

export default memo(Collaborative);